import { CommonModule } from "@angular/common";
import { Component, inject } from "@angular/core";
import {
  ReactiveFormsModule,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import { DialogRef } from "@angular/cdk/dialog";
import { NetlifyFormsService } from "../../services/netlify-forms/netlify-forms.service";

@Component({
  standalone: true,
  selector: "jnguyen-contact-dialog",
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: "./contact.component.html",
})
export class ContactDialogComponent {
  private readonly dialogRef = inject(DialogRef<ContactDialogComponent>);
  private readonly netlifyForms = inject(NetlifyFormsService);

  submitting = false;
  submitted = false;
  error = false;

  contactForm = new UntypedFormGroup({
    firstName: new UntypedFormControl("", [Validators.required]),
    lastName: new UntypedFormControl("", [Validators.required]),
    email: new UntypedFormControl("", [Validators.required, Validators.email]),
    phone: new UntypedFormControl(""),
    other: new UntypedFormControl(""),
  });

  close(): void {
    this.dialogRef.close();
  }

  onSubmit(): void {
    if (this.contactForm.invalid) {
      this.contactForm.markAllAsTouched();
      return;
    }

    this.error = false;
    this.submitting = true;

    this.netlifyForms.submitForm(this.contactForm.value, "contactForm").subscribe({
      next: () => {
        this.contactForm.reset();
        this.submitted = true;
        this.submitting = false;
      },
      error: () => {
        this.error = true;
        this.submitting = false;
      },
    });
  }
}
